import { render } from "./NewbiePath.vue?vue&type=template&id=444d260a&scoped=true"
import script from "./NewbiePath.vue?vue&type=script&lang=js"
export * from "./NewbiePath.vue?vue&type=script&lang=js"

import "./NewbiePath.vue?vue&type=style&index=0&id=444d260a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-444d260a"]])

export default __exports__